var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.89893 9.00069V4.41736C3.89893 4.2516 3.96477 4.09263 4.08198 3.97542C4.19919 3.85821 4.35817 3.79236 4.52393 3.79236H17.0239C17.1897 3.79236 17.3487 3.85821 17.4659 3.97542C17.5831 4.09263 17.6489 4.2516 17.6489 4.41736V9.00069C17.6489 15.5644 12.0781 17.739 10.9658 18.1078C10.8415 18.1506 10.7064 18.1506 10.582 18.1078C9.46971 17.739 3.89893 15.5644 3.89893 9.00069Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2114 8.16736L9.62807 12.5424L7.33643 10.3549",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternal);
export default __webpack_public_path__ + "static/media/Internal.4f3a1d7e9daa287c1077591298aa69cb.svg";
export { ForwardRef as ReactComponent };